import { Component, Shark, Utils } from "shark-mvc";
import $ from "jquery";
import moment from "moment";

import templateContent from "./quotation-actions.html";

import { applicatorTeamComponent } from "../../components/applicatorTeamComponent";
import ccaDetailsManager from "../../controllers/ccaDetailsManager";
import { clientManager } from "../../_shark_jaws/managers/clientManager";
import { constructionSiteCardManager } from "../../_shark_jaws/managers/constructionSiteCardManager";
import { documentManager } from "../../_shark_jaws/managers/documentManager";
import followUpManager from "../../_shark_jaws/managers/followUpManager";
import { informationModalComponent } from "../../components/informationModal/informationModalComponent";
import { quotationManager } from "../../_shark_jaws/managers/quotationManager";
import { siteInfoSheetManager } from "../../_shark_jaws/managers/siteInfoSheetManager";
import teamUpManager from "../../_shark_jaws/managers/teamUpManager";
import { userManager } from "../../_shark_jaws/managers/userManager";
import { visitManager } from "../../_shark_jaws/managers/visitManager";
import waitBoxComponent from "../waitBox/waitBoxComponent";
import { communicationManager } from "../../_shark_jaws/managers/communicationManager";
import ConstructionSiteCard from "../../_shark_models/ConstructionSiteCard";

class QuotationActionsComponent extends Component {
	constructor () {
		super("quotationActionsComponent");
		this.addTemplate("", templateContent);
	}

	addConstructionSiteLotBtn_clickHandler () {
		const currQuotation = Shark.get("currQuotation");
		currQuotation.addConstructionSiteLot();
		Shark.render();
	}

	addQuotationPictureBtn_clickHandler () {
		document.querySelector("#addQuotationPictureBtn").classList.add("loading");
	
		setTimeout(() => {
			document.querySelector("#uploadedQuotationPicture").click();
		}, 100);
	}
	
	afterRender () {
		if (this.get("open")) {
			this.open();
		}
	}

	checkProposalGroup () {
		const currQuotation = Shark.get("currQuotation");

		return siteInfoSheetManager.getByGuid(currQuotation.siteInfoSheetGuid)
		.then(jsonResponse => {
			const currSiteInfoSheet = jsonResponse.data;
			const systemProposalGroupMap = Shark.get("systemProposalGroupMap");
			let proposalGroupCount = 0;

			currSiteInfoSheet.systems.forEach(area => {
				area.systems.forEach(system => {
					system.__proposalLabel = systemProposalGroupMap[system.proposalGroup];
					proposalGroupCount++;
				});
			});

			Shark.set({
				referenceSiteInfoSheet: currSiteInfoSheet,
				__showProposalGroups: proposalGroupCount > 1,
				proposalGroupCount,
			});

			Shark.render();

			if (proposalGroupCount === 1) {
				const quotationActionsConfirmAcceptedBtn = document.querySelector("#quotationActionsConfirmAcceptedBtn");
				if (quotationActionsConfirmAcceptedBtn) {
					currQuotation.__saveEnabled = true;
					quotationActionsConfirmAcceptedBtn.disabled = false;
				}

				currQuotation.extraData.confirmData.premisesDestinations = 	[{
					index: 0,
					label: currSiteInfoSheet.systems[0].premiseDestination,
					proposalGroup: currSiteInfoSheet.systems[0].systems[0].proposalGroup
				}];
			}
			else {
				currQuotation.__showMutliSystemAndMultiLotWarning = currQuotation.__enableLotsManagement;
			}

			return;
		});
	}

	close () {
		this.set({
			open: false,
		});
		$(`#quotationActionsModal`).modal("hide");
	}

	init () {
		this.addComponents([applicatorTeamComponent, informationModalComponent, waitBoxComponent]);

		this.set({
			__showAcceptOptions: false,
			__showActions: false,
			__showCCAForm: false,
			__showRefuseOptions: false,
			__todayISO: moment().format(Shark.get("dtIsoDate"))
		});
	}

	open () {
		$(`#quotationActionsModal`).modal("show");
		this.set({
			open: true,
		});
	}

	premisesDestinations_changeHandler () {
		// Dave.Warn: qui c'è un problema di precedenza degli eventi, questo timeout aiuta, ma è una schifezza.
		setTimeout(() => {
			const { currQuotation, referenceSiteInfoSheet } = Shark.get();
			let activeSystems = 0;
			let premisesDestinations = [];

			referenceSiteInfoSheet.systems.forEach((area, areaIndex) => {
				area.systems.forEach((system, systemIndex) => {
					if (system.__promoteToQuotation) {
						premisesDestinations.push({
							areaIndex,
							index: activeSystems,
							label: area.premiseDestination,
							proposalGroup: parseInt(system.proposalGroup),
							systemIndex,
						});

						activeSystems++;
					}
				});
			});

			currQuotation.extraData.confirmData.premisesDestinations = premisesDestinations;

			const quotationActionsConfirmAcceptedBtn = document.querySelector("#quotationActionsConfirmAcceptedBtn");
			if (quotationActionsConfirmAcceptedBtn) {
				currQuotation.__saveEnabled = activeSystems > 0;
				quotationActionsConfirmAcceptedBtn.disabled = activeSystems === 0;
			}

			console.log({referenceSiteInfoSheet, currQuotation});
		}, 200);
	}

	quotationActionsCancelBtn_clickHandler () {
		const currQuotation = Shark.get("currQuotation");
		currQuotation.extraData.confirmData.pictures = [];
		this.close();
	}

	//Dave.Warn: dato che questa roba è uguale nella conferma del preventivo nel ReplaceQuotationAcceptDocumentComponent
	quotationActionsConfirmAcceptedBtn_clickHandler () {
		const currQuotation = Shark.get("currQuotation");
		const quotationAttachmentsBox = document.querySelector("#quotationAttachmentsBox");
		let errorCount = 0;

		document.querySelectorAll(`.is-invalid`).forEach(item => {
			item.classList.remove("is-invalid");
		});

		if (currQuotation.extraData.confirmData.pictures.length === 0) {
			if (quotationAttachmentsBox) {
				//Dave: Questo schifo è da sistemare con le classi, e andrebbe ripulito all'invio del primo file... ergo, fanne una funzione.
				quotationAttachmentsBox.style.border = "1px solid red";
				quotationAttachmentsBox.querySelector(".alert").classList.remove("d-none");
			}
			errorCount++;
		}
		else {
			if (quotationAttachmentsBox) {
				//Dave: Questo schifo è da sistemare con le classi, e andrebbe ripulito all'invio del primo file... ergo, fanne una funzione.
				quotationAttachmentsBox.style.border = "1px solid rgba(175, 197, 39, 1)";
				quotationAttachmentsBox.querySelector(".alert").classList.add("d-none");
			}
		}

		if (currQuotation.extraData.confirmData.presumedAmount === 0) {
			document.querySelectorAll(`[data-sh-prop="extraData.confirmData.presumedAmount"]`).forEach(item => {
				item.classList.add("is-invalid");
			});
			errorCount++;
		}

		if (errorCount > 0) {
			return;
		}

		waitBoxComponent.open();
		
		if (currQuotation) {
			let jpegAttachments = [];
			currQuotation.extraData.confirmData.pictures.forEach(item => {
				if (item.type === "jpg" || item.type === "jpeg") {
					jpegAttachments.push(item);
				}
			});

			//Dave: valutare se fare il pdf solo in caso di length > 0
			if (jpegAttachments.length > 0 && jpegAttachments.length === currQuotation.extraData.confirmData.pictures.length) {
				let htmlForPdf = `<html><head>
				<style>
					.with-page-break {
						margin-bottom: 1em
						page-break-before: always;
						page-break-after: always;
					}
				</style>
				<head><body>`;

				jpegAttachments.forEach(item => {
					htmlForPdf += `<div class="with-page-break"><img src="${Shark.get("__cdnURL")}/${item.url}" style="width: 100%"></div>`;
				});

				htmlForPdf += "</body></html>";

				documentManager.htmlToPdf({
					destFolder: "quotation-attachments",
					htmlCode: htmlForPdf,
					saveName: "Preventivo-" + currQuotation.code.replace(" ", "_") + "-conferma.pdf",
				})
				.then(savePDFResponse => {
					console.log({savePDFResponse});

					currQuotation.extraData.confirmData.builtPDFURL = savePDFResponse.data[0];

					quotationActionsComponent.saveConfirmedQuotation();
				});
			}
			else {
				quotationActionsComponent.saveConfirmedQuotation();
			}
		}
	}

	quotationActionsConfirmCCABtn_clickHandler () {
		this.close();
		waitBoxComponent.show();
	
		const { currConstructionSiteCard, currQuotation } = Shark.get();
		
		if (currQuotation) {
			let extraDates;
			let ccaToSearch = currQuotation.lots[currConstructionSiteCard.extraData.lotId].cca || currQuotation.cca;///DAVE DAVE DAVE
	
			if (ccaToSearch !== "") {
				teamUpManager.getEventListByCCA(ccaToSearch)
				.then(getEventListByCCAResponse => {
					const ccaEventList = getEventListByCCAResponse.data;

					//DAve: qui va riscritto tutto col currCCADetails
					if (ccaEventList.length > 0) {
						const applicatorTeamList = Shark.get("applicatorTeamList");
						let applicatorTeamId = "";
		
						extraDates = ccaEventList.map(item => {
							if (applicatorTeamList) {
								const applicatorTeam = Utils.safp(applicatorTeamList, "name", item.constructionApplicatorTeam);
		
								if (applicatorTeam) {
									applicatorTeamId = applicatorTeam.guid;
									item.applicatorTeamId = applicatorTeamId;
								}
							}
							return item;
						});

						if (currConstructionSiteCard.extraData.lotId !== undefined && currConstructionSiteCard.extraData.lotId !== -1) {
							currQuotation.lots[currConstructionSiteCard.extraData.lotId].set({
								applicatorTeamId: extraDates[0].applicatorTeamId,
								cca: ccaToSearch,
								multipleDates: extraDates,
								__timeSpanEnd: extraDates[extraDates.length - 1].constructionEndDateTime.format(Shark.get("dateISOFormat")),
								__timeSpanStart: extraDates[0].constructionStartDateTime.format(Shark.get("dateISOFormat")),
							});
						}
						else {
							currQuotation.set({
								"extraData.confirmData.timeSpanAndApplicatorTeam.applicatorTeamId": extraDates[0].applicatorTeamId,
								"extraData.confirmData.timeSpanAndApplicatorTeam.extraDates": extraDates,
								"__timeSpanEnd": extraDates[extraDates.length - 1].constructionEndDateTime.format(Shark.get("dateISOFormat")),
								"__timeSpanStart": extraDates[0].constructionStartDateTime.format(Shark.get("dateISOFormat")),
							});
						}
		
						console.log({extraDates, applicatorTeamList, currQuotation});
					}
					else {
						informationModalComponent.show({body: "Attenzione, la CCA inserita non corrisponde a nessun evento sul calendario TeamUp", title: "Informazione"});
					}

					//Dave: Questa roba è da rivedere, la CCA non sta nel preventivo.
					if (getEventListByCCAResponse.currCCADetails) {
						//Dave: ok, ora il giro del CCADetails funziona, ma ne viene creato uno nuovo ogni volta, dovrei staticizzare la cosa facendo in modo che ad ogni save controllo se esiste già una CCA nel DB e la aggiorno
						const currCCADetails = getEventListByCCAResponse.currCCADetails;

						ccaDetailsManager.save(currCCADetails)
						.then(saveResponse => {
							console.log({currCCADetails, saveResponse});

							// currQuotation.set({
							// 	cca: currCCADetails.cca,
							// 	ccaDetailsGuid: currCCADetails.guid,
							// });

							this.saveQuotationAfterCCAUpdates(ccaToSearch, currQuotation, currConstructionSiteCard, extraDates, currCCADetails);
						});
					}
					else {
						this.saveQuotationAfterCCAUpdates(ccaToSearch, currQuotation, currConstructionSiteCard, extraDates);
					}
				});
			}
			else {
				if (confirm("Attenzione!\n\nStai cancellando la CCA, questo riporterà la Scheda Cantiere in status 'In Attesa', vuoi proseguire?")) {
					console.log("ok, farei");

					if (currConstructionSiteCard.extraData.lotId !== undefined && currConstructionSiteCard.extraData.lotId !== -1) {
						currQuotation.lots[currConstructionSiteCard.extraData.lotId].set({
							applicatorTeamId: "",
							cca: ccaToSearch,
							multipleDates: [],
							__timeSpanEnd: "",
							__timeSpanStart: "",
						});
					}
					else {
						currQuotation.set({
							"extraData.confirmData.timeSpanAndApplicatorTeam.applicatorTeamId": "",
							"extraData.confirmData.timeSpanAndApplicatorTeam.extraDates": [],
							"__timeSpanEnd": "",
							"__timeSpanStart": "",
						});
					}
					this.saveQuotationAfterCCAUpdates(ccaToSearch, currQuotation, currConstructionSiteCard, null);

				}
			}
		}
	}

	quotationActionsConfirmRefusedBtn_clickHandler () {
		this.close();
		const currQuotation = Shark.get("currQuotation");
		
		if (currQuotation) {
			currQuotation.responseDate = moment();
			currQuotation.status = 3;

			quotationManager.save(currQuotation)
			.then(() => {
				// const currUser = Shark.get("currUser");
				const quotationAgent = Utils.safp(Shark.get("userList"), "guid", currQuotation.siteInfoSheetData.agentGuid);
				let refuseReason = currQuotation.extraData.refuseReason;
				refuseReason = refuseReason !== "" ? ` È stata inserita la seguente motivazione: <q role="user-notes">${refuseReason}</q>` : "";

				if (quotationAgent) {
					communicationManager.quotationSetAsRefused(currQuotation, quotationAgent);
				}

				//Dave: Questo è sicuramente da spostare in una funzione perché lo faccio in più posti, tipo un visitQuotationResynch
				visitManager.getBySiteInfoSheetGuid(currQuotation.siteInfoSheetGuid)
				.then(getVisitResponse => {
					const visit = getVisitResponse.data[0];

					if (visit && visit.extraData.quotations) {
						visit.extraData.quotations.forEach(item => {
							if (item.guid === currQuotation.guid) {
								item.status = currQuotation.status;
							}
						});
						visitManager.save(visit)
						.then(visitSaveResponse => console.log({visitSaveResponse}));
					}
				});

				siteInfoSheetManager.setStatus({guid: currQuotation.siteInfoSheetGuid, status: 3})
				.then(updateSiteInfoSheetResponse => {
					console.log("Ho aggiornato lo status della SIS", {updateSiteInfoSheetResponse});
				});

				const newFollowUp = Shark.getInstance("ClientFollowUp", {
					body: `Impostato il Preventivo '${currQuotation.code}' come <span style="color: red;">rifiutato</span>.${refuseReason}`,
					clientGuid: currQuotation.clientGuid,
					referenceGuid: currQuotation.guid,
					referenceType: "quotation",
					status: 3,
					type: "system"
				});
				console.log(newFollowUp);
		
				followUpManager.save(newFollowUp)
				.then(sharkResponse => {
					console.log({sharkResponse});
				});

				if (Shark.activePage.refreshList) {
					Shark.activePage.refreshList();
				}
				else {
					Shark.render();
				}
			});
		}
	}
	
	removeConstructionSiteLotBtn_clickHandler (event, data) {
		if (confirm("Sei sicuro di voler rimuovere il lotto indicato?\nNon sarà possibile annullare.")) {
			const currQuotation = Shark.get("currQuotation");
			currQuotation.removeConstructionSiteLot(data.index);
		}
	}

	saveConfirmedQuotation () {
		const [currQuotation, currUser] = Shark.get(["currQuotation", "currUser"]);

		if (currQuotation) {
			currQuotation.responseDate = moment();
			currQuotation.status = 2;
			currQuotation.extraData.confirmData.userGuid = currUser.guid;

			if (currQuotation.lots.length === 1 && !currQuotation.__enableLotsManagement) {
				// currQuotation.lots[0].area = currQuotation.__presumedArea;
				currQuotation.lots[0].expetedAmount = currQuotation.extraData.confirmData.presumedAmount;
				currQuotation.lots[0].status = 1;
			}
			console.log({currQuotation});

			quotationManager.save(currQuotation)
			.then(() => {
				const quotationAgent = Utils.safp(Shark.get("userList"), "guid", currQuotation.siteInfoSheetData.agentGuid);

				if (quotationAgent) {
					//Dave: Spostare nel communicationManager!
					const body = `BuonGiorno ${quotationAgent.firstName},
						questa eMail per comunicare che il preventivo ${currQuotation.pdfURL ? currQuotation.pdfURL.substr(53) : ""}, relativo alla scheda informativa del <strong>${currQuotation.__siteInfoSheetDate}</strong> per <strong>${currQuotation.clientName}</strong> è stato impostato come <span style="color: green;">accettato</span>.

						Puoi visualizzare il Preventivo <a href="${Shark.get("__cdnURL")}/${currQuotation.pdfURL}">cliccando qui</a>.
						
						Puoi visualizzare la lista dei Preventivi <a href="${Shark.get("agentAppURL")}/#quotationListView">cliccando qui</a>.

						Buona Giornata,
						IPM HUB
					`;

					const currMessage = Shark.getInstance(null, {
						body,
						senderEMail: currUser.email,
						senderName: currUser.__fullName,
						subject: "IPM HUB | Preventivo accettato",
						receiverEMail: quotationAgent.email,
						receiverName: quotationAgent.__fullName,
					});
					userManager.sendMessage(currMessage);
				}

				//Dave: Questo è sicuramente da spostare in una funzione perché lo faccio in più posti, tipo un visitQuotationResynch
				//Dave.Warn: Questa roba è da rivedere alla luce dei lotti multipli, la gestione dello stato del report deve cambiare
				visitManager.getBySiteInfoSheetGuid(currQuotation.siteInfoSheetGuid)
				.then(getVisitResponse => {
					const visit = getVisitResponse.data[0];

					if (visit && visit.extraData.quotations) {
						visit.extraData.quotations.forEach(item => {
							if (item.guid === currQuotation.guid) {
								item.status = currQuotation.status;
							}
						});
						visitManager.save(visit)
						.then(visitSaveResponse => console.log({visitSaveResponse}));
					}
				});

				const newFollowUp = Shark.getInstance("ClientFollowUp", {
					body: `Impostato il Preventivo <q>${currQuotation.code}</q> come <span style="color: #AFC527;">accettato</span>. Il progetto prevede ${currQuotation.lots.length} lott${currQuotation.lots.length === 1 ? "o" : "i"}`,
					clientGuid: currQuotation.clientGuid,
					referenceGuid: currQuotation.guid,
					referenceType: "quotation",
					status: 3,
					type: "system"
				});
				console.log(newFollowUp);
		
				followUpManager.save(newFollowUp)
				.then(sharkResponse => {
					console.log({sharkResponse});
				});

				clientManager.getByGuid(currQuotation.clientGuid)
				.then(getClientResponse => {
					console.log({getClientResponse});
					const currClient = getClientResponse.data;

					if (currClient.promoteToClient()) {
						clientManager.save(currClient)
						.then(saveClientResponse => {
							console.log({currClient, saveClientResponse});
						});
					}
				});

				this.close();
				waitBoxComponent.close();
				Shark.render();
			});
		}
	}

	saveQuotationAfterCCAUpdates (ccaToSearch, currQuotation, currConstructionSiteCard, extraDates, currCCADetails = null) {
		quotationManager.save(currQuotation)
		.then(() => {
			let body;

			if (ccaToSearch === "") {
				body = `È stata rimossa la CCA per il lotto #${currConstructionSiteCard.extraData.lotId + 1} del Preventivo <q>${currQuotation.code}</q>. La Scheda Cantiere è stata riportata in status "In Attesa".`;
			}
			else {
				body = `Impostata la CCA <q>${ccaToSearch}</q> per il lotto #${currConstructionSiteCard.extraData.lotId + 1} del Preventivo <q>${currQuotation.code}</q>.`;
			}
		
			const newFollowUp = Shark.getInstance("ClientFollowUp", {
				body,
				clientGuid: currQuotation.clientGuid,
				referenceGuid: currConstructionSiteCard.guid,
				referenceType: "constructionSiteCard",
				status: 3,
				type: "system"
			});
			console.log(newFollowUp);
	
			followUpManager.save(newFollowUp)
			.then(sharkResponse => {
				console.log({sharkResponse});
			});

			//Ho la sensazione che questo giro non serva più perché non posso più impostare la CCA per un intero preventivo, devo sempre passare dai lotti e quindi dalle CSC.
			constructionSiteCardManager.getByQuotation(currQuotation)
			.then(getConstructionSiteCardResponse => {
				if (getConstructionSiteCardResponse.data.length > 0) {
					const foundConstructionSiteCard = getConstructionSiteCardResponse.data.filter(item => item.guid === currConstructionSiteCard.guid)[0];
					// const currConstructionSiteCard = getConstructionSiteCardResponse.data[0];
					const previousStatus = foundConstructionSiteCard.status;
					let newStatus = foundConstructionSiteCard.status;
					//Dave: Qui andrebbe gestita la situazione in cui la CCA viene messa dopo il documento, quindi dovrebbe partire la mail.
					// let statusMessage = "";

					if (previousStatus === ConstructionSiteCard.STATUS_WAITING && foundConstructionSiteCard.extraData.constructionSiteWorksheetDocumentGuid !== "") {
						newStatus = ConstructionSiteCard.STATUS_READY_TO_START;
						// statusMessage = "\nIl Cantiere è ora pronto a partire.\n";
					}
					else if (previousStatus === ConstructionSiteCard.STATUS_READY_TO_START && ccaToSearch === "") {
						newStatus = ConstructionSiteCard.STATUS_WAITING;
					}
			
					foundConstructionSiteCard.set({
						ccaDetailsGuid: currCCADetails ? currCCADetails.guid : "",
						"extraData.quotationCCA": ccaToSearch,
						status: newStatus,
					});
					
					// currConstructionSiteCard.extraData.quotationCCA = currQuotation.cca;

					if (extraDates) {
						foundConstructionSiteCard.set({
							applicatorTeamId: extraDates[0].applicatorTeamId,
							quotationExtraData: currQuotation.extraData,
							__endDate: extraDates[extraDates.length - 1].constructionEndDateTime.format(Shark.get("dateISOFormat")),
							__startDate: extraDates[0].constructionStartDateTime.format(Shark.get("dateISOFormat")),
						});
					}
					else {
						foundConstructionSiteCard.set({
							applicatorTeamId: "",
							quotationExtraData: [],
							__endDate: "",
							__startDate: "",
						});
					}

					console.log({getConstructionSiteCardResponse});
					
					//Dave: QUi non serve un FU?
					constructionSiteCardManager.save(foundConstructionSiteCard)
					.then(constructionSiteCardSaveResponse => {
						console.log({constructionSiteCardSaveResponse});

						if (newStatus === ConstructionSiteCard.STATUS_READY_TO_START && previousStatus !== newStatus) {
							constructionSiteCardManager.checkCommunicateStarting(foundConstructionSiteCard);
						}

						//Dave: Schifezza
						if (Shark.activePage.id === "constructionSiteCardListView") {
							Shark.activePage.refreshList();
						}
						else {
							waitBoxComponent.hide();
							Shark.render();
						}
					});
				}
				else {
					waitBoxComponent.hide();
					Shark.render();
				}
			});
		});

	}

	show (mode) {
		const currQuotation = Shark.get("currQuotation");

		this.set({
			__showAcceptOptions: mode === "accept",
			__showActions: mode === "actions",
			__showCCAForm: mode === "cca",
			__showRefuseOptions: mode === "refuse",
		});

		//Dave: Questa roba è oscena, non posso farlo due volte!!!
		siteInfoSheetManager.getByGuid(currQuotation.siteInfoSheetGuid)
		.then(jsonResponse => {
			const currSiteInfoSheet = jsonResponse.data;

			//Dave: Non capisco perché lo rifaccio qui, devo revisionare tutto il giro.
			currQuotation.set({
				"extraData.confirmData.timeSpanAndApplicatorTeam.applicatorTeamId": currSiteInfoSheet.timeSpanAndApplicatorTeam.applicatorTeamId,
				"__timeSpanStart": currSiteInfoSheet.timeSpanAndApplicatorTeam.timeSpanStart.isValid() ? currSiteInfoSheet.timeSpanAndApplicatorTeam.timeSpanStart.format(Shark.get("dtIsoDate")) : "",
				"__timeSpanEnd": currSiteInfoSheet.timeSpanAndApplicatorTeam.timeSpanEnd.isValid() ? currSiteInfoSheet.timeSpanAndApplicatorTeam.timeSpanEnd.format(Shark.get("dtIsoDate")) : "",
			});

			Shark.render();

			if (["accept"].indexOf(mode) > -1) {
				this.checkProposalGroup()
				.then(() => {
					this.open();
				});
			}
			else {
				this.open();
			}
		});
	}

	uploadedQuotationPicture_changeHandler (event) {
		waitBoxComponent.open();

		quotationManager.uploadPicture(event.target)
		.then(uploadPictureResponse => {
			document.querySelector("#addQuotationPictureBtn").classList.remove("loading");

			// const pictureCount = uploadPictureResponse.data.extraData.confirmData.pictures.length;
			const thumbnails = uploadPictureResponse.data.extraData.confirmData.pictures.map(item => {
				return `<div class="col">
					<img alt="${item.label}" class="document-image" src="${item.thumbURL.substr(0, 6) === "images" ? item.thumbURL : Shark.get("__cdnURL") + "/" + item.thumbURL}">
					<br>${item.label} (${(item.size / 1048576).toFixed(2)}MB)
				</div>`;
			});
	
			document.querySelector("#uploadedQuotationPicturesBox").innerHTML = thumbnails.join("");
			document.querySelector("#uploadedQuotationPicture").dataset.saveName = Shark.__generateGUID();
	
			waitBoxComponent.close();
		});
	}
}

const quotationActionsComponent = new QuotationActionsComponent();

Shark.registerComponent(quotationActionsComponent);

export { quotationActionsComponent };
